import { render } from "./TheLeftSidebar.vue?vue&type=template&id=66c3b964"
import script from "./TheLeftSidebar.vue?vue&type=script&lang=js"
export * from "./TheLeftSidebar.vue?vue&type=script&lang=js"

import "./TheLeftSidebar.vue?vue&type=style&index=0&id=66c3b964&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__